import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {PointOfInterestSearchParams} from '../../point-of-interest-search-params';
import {PointOfInterest} from '../../point-of-interest';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-point-of-interest-list',
  templateUrl: './point-of-interest-list.component.html',
  styleUrls: []
})
export class PointOfInterestListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new PointOfInterestSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/point-of-interest', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: PointOfInterest) {
    this.router.navigateByUrl(`/point-of-interest/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/point-of-interest/create']);
  }
}
